import { createReducer, on } from '@ngrx/store';

import { TrialAccountRequestActions } from './actions';
import {
  trialAdapter,
  trialInitialState,
  TrialAccountsRequestsState,
} from './state';

const getRequestsReducer = [
  on(
    TrialAccountRequestActions.GetItems.request,
    (state: TrialAccountsRequestsState) => ({
      ...state,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    TrialAccountRequestActions.GetItems.success,
    (state: TrialAccountsRequestsState, { items, httpFilters }) =>
      trialAdapter.setAll(items, {
        ...state,
        filters: httpFilters,
        isLoading: false,
      }),
  ),
  on(
    TrialAccountRequestActions.GetItems.failed,
    (state: TrialAccountsRequestsState) => ({
      ...state,
      isLoading: false,
      filters: [...(state.filters || [])],
    }),
  ),
];

const requestApproveReducer = [
  on(
    TrialAccountRequestActions.RequestApprove.request,
    (state: TrialAccountsRequestsState) => ({
      ...state,
      error: null,
    }),
  ),
  on(
    TrialAccountRequestActions.RequestApprove.success,
    (state: TrialAccountsRequestsState, { requestId }) =>
      trialAdapter.removeOne(requestId, state),
  ),
];

const requestDeclineReducer = [
  on(
    TrialAccountRequestActions.RequestDecline.request,
    (state: TrialAccountsRequestsState) => ({
      ...state,
      error: null,
    }),
  ),
  on(
    TrialAccountRequestActions.RequestDecline.success,
    (state: TrialAccountsRequestsState, { requestId }) =>
      trialAdapter.removeOne(requestId, state),
  ),
];

const addFilterReducer = [
  on(
    TrialAccountRequestActions.Filters.add,
    (state: TrialAccountsRequestsState, { filters }) => ({
      ...state,
      filters,
    }),
  ),
];

const failureReducer = [
  on(
    TrialAccountRequestActions.failure,
    (state: TrialAccountsRequestsState, { errorMessage }) => ({
      ...state,
      isLoading: false,
      error: errorMessage,
    }),
  ),
];

export const TrialAccountReducer = createReducer<TrialAccountsRequestsState>(
  trialInitialState,
  ...getRequestsReducer,
  ...requestApproveReducer,
  ...requestDeclineReducer,
  ...addFilterReducer,
  ...failureReducer,
);
